// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import pagesReducer, { PagesActions } from "@store/Extensions/Store/Pages/PagesReducer";
import mergeReducer from "@toolkit/Framework/Common/Utilities/redux/mergeReducer";

reducers.pages = mergeReducer(reducers.pages, pagesReducer);

export type ExtendedActions = PagesActions;
